import styles from './PageGutter.module.scss'
import { HTMLAttributes, PropsWithChildren, RefObject } from 'react'
import { classNames } from '@/src/helpers/component'

export interface PageGutterProps extends HTMLAttributes<HTMLDivElement> {
  ref?: RefObject<HTMLDivElement | null>
}

export default function PageGutter({ children, ...props }: PropsWithChildren<PageGutterProps>) {
  return (
    <div {...props} className={classNames('--page-gutter', styles.container, props.className)}>
      {children}
    </div>
  )
}
